import React, { useEffect, useState } from "react";


import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import RegularMealStatus from "./regularmealstatus";
import RegularMealCalendar from "./regularmealcalendar";
import { koreanLocationToEnglish } from "../../../../data/locationFuntion";
import { getFetch } from "../../../../fetch/fetch";
import RegularMealRefund from "./regularmealrefund";
import RegularmealTable2 from "./component/regularealtable2";



const RegularMealStatusTotal: React.FC<any> = (props) => {

    const [value, setValue] = useState(0);
    const [loading, setLoading] = useState<boolean>(false);


    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    }; 

    return (
        <div>
            <div style={{ width: "1500px", margin: "0 auto", paddingTop : "40px" }}>
                <Box sx={{ width: "100%", marginBottom: "0px" }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered>
                            <Tab label="날짜별로 보기" value={0} />
                            {
                                props.user
                                &&
                                <Tab label="표로 보기" value={props.user.academy === "sunbae" ? 1 : 3} />
                            }
                            <Tab label="식권 관리" value={2} />
                        </Tabs>
                    </Box>
                </Box>
            </div>


            <div>
                {
                    value === 0
                    ?
                    <RegularMealCalendar 
                    user={props.user}
                    />
                    :
                    ""
                }
                {
                    value === 1 
                    ?
                    (
                        <RegularMealStatus
                        user={props.user}
                        />
                    )
                    :
                    ""
                }
                {
                    value === 2
                    ?
                    (
                        <RegularMealRefund
                        user={props.user}
                        />
                    )
                    :
                    ""
                }
                {
                    value === 3
                    ?
                    (
                        <RegularmealTable2
                        user={props.user}
                        />
                    )
                    :
                    ""
                }
            </div>
        </div>
    )
}

export default RegularMealStatusTotal;